export var PlaiViewType;
(function (PlaiViewType) {
    PlaiViewType["Review"] = "review";
    PlaiViewType["Playbook"] = "playbook";
})(PlaiViewType || (PlaiViewType = {}));
